import {React} from 'common'
import {List, Menu} from '@mui/material'
import {menuActions, menuItems, menuIcons} from 'constants/sideMenu'
import {getLayoutDirection, useNavigate} from 'services/hooks'
import {useIsRtl} from 'store/Store'
import SideMenuItem from 'components/Page/SideMenu/SideMenuItem'
import {Styles} from 'appearance'

const MobileSideMenu = ({
    mobileSideAnchorEl,
    mobileSideMenuId,
    isMobileSideMenuOpen,
    handleMobileSideMenuClose,
}) => {
    const navigate = useNavigate()
    const isRtl = useIsRtl()
    const dir = getLayoutDirection(isRtl)

    return (
        <Menu
            dir={dir}
            anchorEl={mobileSideAnchorEl}
            anchorOrigin={Styles.MENU_ANCHOR_ORIGIN}
            id={mobileSideMenuId}
            keepMounted
            open={isMobileSideMenuOpen}
            onClose={handleMobileSideMenuClose}>
            <List>
                {menuItems.map((text, index) => (
                    <SideMenuItem
                        key={text}
                        open={isMobileSideMenuOpen}
                        onClick={() => menuActions?.[text](navigate)}
                        icon={menuIcons[text]}
                        text={text}
                    />
                ))}
            </List>
        </Menu>
    )
}

export default MobileSideMenu
